import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    selectedFileListPlacement: 'left' | 'right';
  }>()
  .create(({ selectedFileListPlacement, theme }) => ({
    fileUploader: {
      alignItems: 'flex-start',
      width: '100%'
    },
    fileUploaderAlert: {
      width: '100%',
      display: 'flex',
      justifyContent:
        selectedFileListPlacement === 'left' ? 'flex-end' : 'flex-start'
    },
    fileUploaderChip: {
      backgroundColor: 'transparent',
      color: theme.vars.palette.primary.light,
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.vars.palette.text.primary
      },
      '&:focus': {
        backgroundColor: 'transparent',
        color: theme.vars.palette.text.primary
      },
      [theme.breakpoints.up('lg')]: {
        marginLeft: theme.spacing(1)
      }
    },
    fileUploaderFileInput: {
      display: 'none'
    },
    fileUploaderRejected: {
      color: theme.vars.palette.text.secondary
    }
  }));

export default useStyles;
